<template>
  <div class="el-panel">
    <div class="el-panel_header">{{ title }}</div>
    <transition name="el-zoom-in-top">
      <div class="el-panel_content">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    title: String
  }
}
</script>

<style lang="scss">
.el-panel {
  .el-panel_header {
    background-color: #f5f7fa;
    padding: 1rem;
    font-size: 1.2rem;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
  }
  .el-panel_content {
    padding: 1rem;
  }
}
</style>